var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import * as analytics from '@adsk/acs-web-analytics';
import { noop, memoize, uniq, debounce } from 'lodash';
import styled from 'styled-components';
import { useDropdownTree, ACTIONS as TREE_ACTIONS, } from '@adsk/alloy-react-tree';
import { LocationsDropdownTreeSingle, LocationsDropdownTreeMultiple, } from './components';
import { LOCATION_PICKER_ANALYTIC_EVENTS, LOCATION_PICKER_ANALYTICS_ACTIONS, MAX_SELECTED_NODES, } from '../consts';
import { usePrevious } from './hooks';
import { getNodeAncestors, getNodeDescendants, listToTree, } from '../helpers/treeHelpers';
import { useLocations } from '../LocationProvider/LocationProvider';
import { getTotalSelectedCount } from '../helpers/treeHelpers';
import { useUnspecifiedProps } from '../helpers/unspecifiedHelper';
export var FEATURE_TEAMS;
(function (FEATURE_TEAMS) {
    FEATURE_TEAMS["ISSUES"] = "issues";
    FEATURE_TEAMS["SHEETS"] = "sheets";
    FEATURE_TEAMS["ASSETS"] = "assets";
    FEATURE_TEAMS["FORMS"] = "forms";
    FEATURE_TEAMS["PHOTOS"] = "photos";
    FEATURE_TEAMS["SCHEDULE"] = "schedule";
    FEATURE_TEAMS["COST"] = "cost";
    FEATURE_TEAMS["RFIS"] = "rfis";
    FEATURE_TEAMS["SUBMITTALS"] = "submittals";
    FEATURE_TEAMS["TAKEOFF"] = "takeoff";
})(FEATURE_TEAMS || (FEATURE_TEAMS = {}));
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["ASSIGN"] = "assign";
    ACTIONS["FILTER"] = "filter";
})(ACTIONS || (ACTIONS = {}));
var LocationPickerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border: ", ";\n"], ["\n  width: 100%;\n  border: ", ";\n"])), function (props) { return (props.invalid ? '1px solid red' : ''); });
LocationPickerContainer.displayName = 'LocationPickerContainer';
export var LocationPicker = function (_a) {
    var _b = _a.onNodeSelect, onNodeSelect = _b === void 0 ? noop : _b, _c = _a.onIncludeSubLocation, onIncludeSubLocation = _c === void 0 ? noop : _c, selectLocationPlaceHolder = _a.selectLocationPlaceHolder, searchPlaceholder = _a.searchPlaceholder, maxCardHeight = _a.maxCardHeight, _d = _a.clearable, clearable = _d === void 0 ? true : _d, _e = _a.invalid, invalid = _e === void 0 ? false : _e, isOpen = _a.isOpen, _f = _a.onOpen, onOpen = _f === void 0 ? noop : _f, _g = _a.onClose, onClose = _g === void 0 ? noop : _g, selectedNodeId = _a.selectedNodeId, selectedNodesIds = _a.selectedNodesIds, controlledIncludeSublocations = _a.includeSubLocations, _h = _a.hideIncludeSubLocations, hideIncludeSubLocations = _h === void 0 ? false : _h, _j = _a.multiple, multiple = _j === void 0 ? false : _j, featureTeam = _a.featureTeam, action = _a.action, _k = _a.className, className = _k === void 0 ? '' : _k, _l = _a.style, style = _l === void 0 ? {} : _l, _m = _a.treeClassName, treeClassName = _m === void 0 ? '' : _m, _o = _a.treeStyle, treeStyle = _o === void 0 ? {} : _o, _p = _a.disabled, disabled = _p === void 0 ? false : _p, _q = _a.container, container = _q === void 0 ? document.body : _q, _r = _a.showIncludeUnspecified, shouldShowIncludeUnspecified = _r === void 0 ? false : _r, _s = _a.includeUnspecified, includeUnspecified = _s === void 0 ? false : _s, _t = _a.onUnspecifiedSelect, onUnspecifiedSelect = _t === void 0 ? function () { } : _t;
    var showIncludeUnspecified = Boolean(shouldShowIncludeUnspecified) && Boolean(multiple);
    var _u = useLocations(), treeData = _u.treeData, treeDataMap = _u.treeDataMap, isLoading = _u.isLoading;
    var _v = __read(useState([]), 2), selectedNodes = _v[0], setSelectedNodes = _v[1];
    var _w = __read(useState(controlledIncludeSublocations !== null && controlledIncludeSublocations !== void 0 ? controlledIncludeSublocations : false), 2), includeSubLocation = _w[0], setIncludeSubLocation = _w[1];
    var _x = __read(useState(isOpen || false), 2), isTreeOpen = _x[0], _setIsTreeOpen = _x[1];
    var _y = __read(useState(''), 2), searchTerm = _y[0], setSearchTerm = _y[1];
    var locationPickerRef = useRef();
    var previousSelectedNodeId = usePrevious(selectedNodeId);
    var previousSelectedNodesIds = usePrevious(selectedNodesIds);
    var previousIncludeSubLocation = usePrevious(includeSubLocation);
    var previousIsOpen = usePrevious(isOpen);
    var previousIsLoading = usePrevious(isLoading);
    var unspecifiedId = useUnspecifiedProps().unspecifiedId;
    var trackEvent = useCallback(function (eventName, eventProps) {
        var commonAnalyticProps = {
            'Feature team': featureTeam || 'None',
            Action: action || 'None',
        };
        analytics.track(eventName, __assign(__assign({}, commonAnalyticProps), eventProps));
    }, [featureTeam, action]);
    var setIsTreeOpen = useCallback(function (newVal) {
        if (newVal && isTreeOpen === false) {
            var openLocationPickerEventProps = {
                'Is multiple': multiple,
                'Selected nodes': selectedNodes.length,
            };
            trackEvent(LOCATION_PICKER_ANALYTIC_EVENTS.OPEN, openLocationPickerEventProps);
        }
        if (!newVal) {
            setSearchTerm('');
        }
        _setIsTreeOpen(newVal);
    }, [isTreeOpen, multiple, selectedNodes.length, trackEvent]);
    // Handle controlled selection
    useEffect(function () {
        var _a;
        if (isLoading) {
            return;
        }
        var currentSelectedNodesIds = selectedNodes.map(function (node) { return node && node.id; });
        if (!multiple &&
            selectedNodeId !== undefined &&
            (selectedNodeId !== previousSelectedNodeId ||
                (!isLoading && previousIsLoading)) &&
            selectedNodeId !== ((_a = selectedNodes[0]) === null || _a === void 0 ? void 0 : _a.id)) {
            setSelectedNodes(selectedNodeId && treeDataMap[selectedNodeId]
                ? [treeDataMap[selectedNodeId]]
                : []);
        }
        else if (multiple &&
            selectedNodesIds !== undefined &&
            (selectedNodesIds !== previousSelectedNodesIds ||
                (!isLoading && previousIsLoading)) &&
            selectedNodesIds !== currentSelectedNodesIds) {
            var selectedNodes_1 = selectedNodesIds
                .map(function (selectedNodeId) { return treeDataMap[selectedNodeId]; })
                .filter(function (node) { return !!node; });
            setSelectedNodes(selectedNodes_1);
        }
    }, [
        selectedNodeId,
        previousSelectedNodeId,
        selectedNodesIds,
        previousSelectedNodesIds,
        treeDataMap,
        selectedNodes,
        multiple,
        isLoading,
        previousIsLoading,
    ]);
    // Handle controlled includeSubLocations
    useEffect(function () {
        if (controlledIncludeSublocations !== undefined &&
            controlledIncludeSublocations !== previousIncludeSubLocation) {
            setIncludeSubLocation(controlledIncludeSublocations);
        }
    }, [controlledIncludeSublocations, previousIncludeSubLocation]);
    // Handle controlled isOpen
    useEffect(function () {
        if (isOpen !== previousIsOpen) {
            setIsTreeOpen(isOpen || false);
        }
    }, [isOpen, previousIsOpen, setIsTreeOpen]);
    var setIsOpenState = function (newVal) {
        if (isOpen !== undefined) {
            newVal ? onOpen() : onClose();
        }
        else {
            setIsTreeOpen(newVal);
        }
        if (newVal && !multiple && selectedNodes[0]) {
            dropdownTreeDispatch({
                type: TREE_ACTIONS.regenerateTree,
                payload: {
                    denormalizedTree: treeData,
                    expandedIds: __assign(__assign({}, expandedIdsRef.current), expandedAncestorsOfSelected),
                },
            });
        }
    };
    var getFilteredTree = memoize(function (searchTerm) {
        var searchCallback = function (node) {
            return node.name.toLowerCase().includes(searchTerm) && node.type !== 'Root';
        };
        var expandedNodeIds = {};
        var results = [];
        Object.values(treeDataMap).forEach(function (node) {
            if (searchCallback(node)) {
                getNodeAncestors(treeDataMap, node).forEach(function (ancestorNode) {
                    expandedNodeIds[ancestorNode.id] = true;
                    results.push(ancestorNode);
                });
                results.push(node);
                getNodeDescendants(treeDataMap, node).forEach(function (decendantNode) {
                    results.push(decendantNode);
                });
            }
        });
        var filteredTree = listToTree(uniq(results));
        return { filteredTree: filteredTree, expandedNodeIds: expandedNodeIds };
    });
    var prevInputValue = useRef('');
    var prevExpandedIds = useRef({});
    var expandedIdsRef = useRef({});
    var searchLocations = useCallback(debounce(function (newSearchTerm) {
        setSearchTerm(newSearchTerm);
    }, 500), [setSearchTerm]);
    var expandedAncestorsOfSelected = useMemo(function () {
        if (!multiple && selectedNodes[0]) {
            return getNodeAncestors(treeDataMap, selectedNodes[0]).reduce(function (prevVal, ancestorNode) {
                var _a;
                return (__assign(__assign({}, prevVal), (_a = {}, _a[ancestorNode.id] = true, _a)));
            }, {});
        }
        return {};
    }, [selectedNodes, multiple]);
    useEffect(function () {
        if (searchTerm === '') {
            dropdownTreeDispatch({
                type: TREE_ACTIONS.regenerateTree,
                payload: {
                    denormalizedTree: treeData,
                    expandedIds: prevExpandedIds.current,
                },
            });
            prevInputValue.current = searchTerm;
            prevExpandedIds.current = {};
            return;
        }
        if (prevInputValue.current === '' && searchTerm.length >= 1) {
            prevExpandedIds.current = __assign({}, expandedIdsRef.current);
        }
        prevInputValue.current = searchTerm;
        var _a = getFilteredTree(searchTerm.toLowerCase()), filteredTree = _a.filteredTree, expandedNodeIds = _a.expandedNodeIds;
        dropdownTreeDispatch({
            type: TREE_ACTIONS.regenerateTree,
            payload: {
                denormalizedTree: filteredTree,
                expandedIds: expandedNodeIds,
            },
        });
    }, [searchTerm]);
    var selectNode = function (nodeId) {
        if (selectedNodes.length >= MAX_SELECTED_NODES) {
            return;
        }
        var nextSelectedNodes = multiple
            ? __spreadArray(__spreadArray([], __read(selectedNodes), false), [treeDataMap[nodeId]], false) : [treeDataMap[nodeId]];
        setSelectedNodes(nextSelectedNodes);
        var totalNodesCount = nextSelectedNodes.length;
        var selectNodeEventProps = {
            'Is multiple': multiple,
            'Selected nodes': nextSelectedNodes.length,
            'Searched nodes': nextSelectedNodes.length,
        };
        if (includeSubLocation) {
            totalNodesCount = getTotalSelectedCount(nextSelectedNodes, treeDataMap);
            selectNodeEventProps['Number of sub locations'] =
                totalNodesCount - nextSelectedNodes.length;
            selectNodeEventProps['Searched nodes'] = totalNodesCount;
        }
        if (multiple) {
            onNodeSelect(nextSelectedNodes, totalNodesCount);
            selectNodeEventProps['Action'] =
                LOCATION_PICKER_ANALYTICS_ACTIONS.ASSIGNED;
        }
        else {
            setIsOpenState(false);
            onNodeSelect(treeDataMap[nodeId], totalNodesCount);
            selectNodeEventProps['Action'] = selectedNodes.length
                ? LOCATION_PICKER_ANALYTICS_ACTIONS.UPDATED
                : LOCATION_PICKER_ANALYTICS_ACTIONS.ASSIGNED;
        }
        trackEvent(LOCATION_PICKER_ANALYTIC_EVENTS.SELECT_NODE, selectNodeEventProps);
    };
    var deselectNode = function (nodeId) {
        // No nodeId on deselect means we're clearing selection
        var selectedNodesAfterSelect = nodeId
            ? selectedNodes.filter(function (selectedNode) { return selectedNode.id !== nodeId; })
            : [];
        setSelectedNodes(selectedNodesAfterSelect);
        var totalNodeCount = 0;
        if (selectedNodesAfterSelect.length > 0) {
            totalNodeCount = includeSubLocation
                ? getTotalSelectedCount(selectedNodesAfterSelect, treeDataMap)
                : selectedNodesAfterSelect.length;
        }
        var selectNodeEventAction;
        if (multiple) {
            onNodeSelect(selectedNodesAfterSelect, totalNodeCount);
            selectNodeEventAction = totalNodeCount
                ? LOCATION_PICKER_ANALYTICS_ACTIONS.UPDATED
                : LOCATION_PICKER_ANALYTICS_ACTIONS.CLEARED;
        }
        else {
            onNodeSelect(null, totalNodeCount);
            selectNodeEventAction = LOCATION_PICKER_ANALYTICS_ACTIONS.CLEARED;
        }
        trackEvent(LOCATION_PICKER_ANALYTIC_EVENTS.SELECT_NODE, {
            Action: selectNodeEventAction,
        });
    };
    var handleNodeSelectToggle = function (_a) {
        var toggledNodeId = _a.id;
        if (showIncludeUnspecified &&
            includeUnspecified &&
            toggledNodeId === unspecifiedId) {
            onUnspecifiedSelect(false);
            return;
        }
        var isSelected = selectedNodes.findIndex(function (_a) {
            var id = _a.id;
            return id === toggledNodeId;
        }) !== -1;
        if (isSelected) {
            deselectNode(toggledNodeId);
        }
        else {
            selectNode(toggledNodeId);
        }
    };
    var clearSelection = function () {
        trackEvent(LOCATION_PICKER_ANALYTIC_EVENTS.CLEARED_CLICKED, {});
        deselectNode(null);
    };
    var onIncludeSubLocationChange = function (value) {
        var totalCount = selectedNodes.length;
        if (value) {
            totalCount = getTotalSelectedCount(selectedNodes, treeDataMap);
            var selectedChildrenCount = totalCount - selectedNodes.length;
            var includeSubLocationEventProps = {
                'Is multiple': multiple,
                'Selected nodes': selectedNodes.length,
                'Searched nodes': totalCount,
            };
            if (selectedNodes.length > 0) {
                includeSubLocationEventProps['Number of sub locations'] = selectedChildrenCount;
            }
            trackEvent(LOCATION_PICKER_ANALYTIC_EVENTS.INCLUDE_SUB_ITEMS, includeSubLocationEventProps);
        }
        setIncludeSubLocation(value);
        onIncludeSubLocation(value, totalCount);
    };
    var selectedIds = useMemo(function () {
        return selectedNodes.reduce(function (prevVal, selectedNode) {
            var _a;
            return (__assign(__assign({}, prevVal), (_a = {}, _a[selectedNode.id] = true, _a)));
        }, {});
    }, [selectedNodes]);
    var getLabelFromNode = useCallback(function (_a) {
        var name = _a.name;
        return name;
    }, []);
    var _z = useDropdownTree({
        denormalizedTree: treeData,
        getLabelFromNode: getLabelFromNode,
        selectedIds: selectedIds,
        onSelect: handleNodeSelectToggle,
    }), normalizedTree = _z.normalizedTree, getTreeNodeProps = _z.getTreeNodeProps, getTreeProps = _z.getTreeProps, dropdownTreeDispatch = _z.dispatch, expandedIds = _z.expandedIds, useDropdownProps = __rest(_z, ["normalizedTree", "getTreeNodeProps", "getTreeProps", "dispatch", "expandedIds"]);
    expandedIdsRef.current = expandedIds;
    // Temp fix till this is fixed in Alloy lib - Tree nodes data is not refreshed when changed after initialization
    useEffect(function () {
        dropdownTreeDispatch({
            type: TREE_ACTIONS.regenerateTree,
            payload: {
                denormalizedTree: treeData,
            },
        });
    }, [treeData]);
    var TreeComponent = multiple
        ? LocationsDropdownTreeMultiple
        : LocationsDropdownTreeSingle;
    return (React.createElement(LocationPickerContainer, { ref: locationPickerRef, className: className, style: style, invalid: invalid },
        React.createElement(TreeComponent, { showIncludeUnspecified: showIncludeUnspecified, includeUnspecified: includeUnspecified, onUnspecifiedSelect: onUnspecifiedSelect, style: treeStyle, className: treeClassName, selectedNodes: selectedNodes, handleNodeSelectToggle: handleNodeSelectToggle, includeSubLocation: includeSubLocation, setIncludeSubLocation: hideIncludeSubLocations ? undefined : onIncludeSubLocationChange, isClearable: clearable, isOpen: isTreeOpen, setIsOpen: setIsOpenState, clearSelection: clearSelection, maxMenuHeight: maxCardHeight, selectLocationPlaceHolder: selectLocationPlaceHolder, searchPlaceholder: searchPlaceholder, searchTerm: searchTerm, searchLocations: searchLocations, getTreeProps: getTreeProps, getTreeNodeProps: getTreeNodeProps, useDropdownProps: useDropdownProps, disabled: disabled, container: container })));
};
var templateObject_1;
